export const locale = {
    lang: "ca",
    data: {
        GLOBAL: {
            SavedChanges: "Canvis guardats",
            CreatedSuccess: "Creat amb èxit",
        },
        USERS: {
            Users: "Usuaris",
            Name: "Nom",
            Email: "Email",
            Admin: "Administrador",
            IsAdmin: "És administrador?",
            Password: "Contrasenya",
            ADD: "AFEGEIX",
            SAVE: "GUARDA",
            CANCEL: "CANCEL·LA",
            Create: "Crea",
            UserName: "Nom",
            BasicInfo: "Informació bàsica",
            PasswordPolicy: "La contrasenya ha de tenir com a mínim {{minLength}} caràcters.",
            PasswordRequired: "La contrasenya és obligatòria",
            PasswordMinLength: "La contrasenya ha de tenir com a mínim {{minLength}} caràcters.",
            PasswordReset: "Restablir contrasenya",
            PasswordResetTitle: "Canviar la contrasenya de l'usuari",
            PasswordResetSuccess: "Contrasenya actualitzada correctament",
            ResetPasswordButton: "Restablir contrasenya",
            NewPassword: "Nova contrasenya",
            ConfirmPassword: "Confirmar contrasenya",
            ConfirmPasswordRequired: "Has de confirmar la contrasenya",
            PasswordsDoNotMatch: "Les contrasenyes no coincideixen",
            Projects: "Projectes",
            Companies: "Empreses",
        },
        COMPANIES: {
            Companies: "Empreses",
            Name: "Nom",
            Street: "Carrer",
            City: "Ciutat",
            ZipCode: "Codi Postal",
            Country: "País",
            BasicInfo: "Info Bàsica",
            Company: "Empresa",
            CompanyName: "Nom Empresa",
            Address: "Adreça",
            ADD: "AFEGIR",
            SAVE: "GUARDAR",
            CANCEL: "CANCEL",
            Projects: "Projectes",
            Create: "Crear",
        },
        DEVICES: {
            ActiveProject: "Projecte Actiu",
            Devices: "Devices",
            Name: "Name",
            Manufacturer: "Manufacturer",
            Model: "Model",
            SerialNumber: "Serial Number",
            DeviceType: "Device Type",
            DataFrequency: "Data Frequency (Seconds)",
            DataFrequencyDevice: "Device Data Frequency (Seconds): ",
            DataFrequencyCustom: "Custom Data Frequency (Seconds): ",
            LF010Host: "Host / IP LF010",
            LF010HostHelp: "Host per consultar dades del dispositiu.",
            LF010HostPlaceholder: "192.168.1.100",
            LF010Password: "Contrasenya LF010",
            LF010PasswordHelp: "Contrasenya opcional. Deixa-la buida per fer servir el valor per defecte actual.",
            LF010PasswordPlaceholder: "admin",
            LF010PeriodMapping: "Assignació de períodes LF010",
            LF010PeriodMappingHelp: "Assigna els tres períodes fixos de l’LF010 als períodes del projecte.",
            LF010DevicePeriod: "Període del dispositiu LF010",
            LF010ProjectPeriodPlaceholder: "Selecciona un període del projecte",
            LF010ApplyAlarm: "Aplicar límits LF010 en desar",
            LF010ApplyAlarmHelp: "Crea o actualitza l’alarma d’emissió gestionada per LF010 amb l’assignació seleccionada.",
            LF010ApplyAlarmPendingHelp:
                "Ja pots desar l’assignació de períodes. L’alarma es podrà aplicar quan la primera ingestió LF010 aporti els límits d’emissió.",
            ProjectPeriod: "Període del projecte",
            LF010SettingsDisabledWhenActive: "Desactiva el dispositiu abans de canviar la configuració de l’LF010.",
            LF010LockedBadge: "Dispositiu en viu",
            LF010LockedTitle: "Els límits i l’assignació de períodes de l’LF010 queden bloquejats mentre el dispositiu és actiu.",
            LF010LockedDescription:
                "La connexió actual de l’LF010 i l’assignació de períodes del projecte continuen visibles com a referència, però no es poden editar fins que desactivis el dispositiu.",
            LF010PeriodMappingLockedHelp:
                "Desactiva el dispositiu per editar l’assignació LF010 o canviar com s’apliquen els seus límits en viu.",
            SimOrImei: "SIM o IMEI",
            LastCalibrationDate: "Data de última calibració",
            Protocol: "Protocol",
            Picture: "Picture",
            Comments: "Comments",
            Location: "Location",
            Active: "Active",
            Device: "Device",
            Activate: "Activate",
            Deactivate: "Deactivate",
            Reset: "Reiniciar",
            ConfirmReset: "Vols reiniciar ara el dispositiu {{deviceName}}? La mesura s’aturarà abans.",
            ResetQueued: "S'ha sol·licitat el reinici",
            ResetAlreadyPending: "Ja hi ha un reinici pendent per a aquest dispositiu",
            ResetRateLimited: "Espera {{seconds}} segons abans de tornar a sol·licitar el reinici",
            OperationTypeReset: "Reinici",
            OperationTypeGeneric: "Operació",
            OperationPending: "Operació pendent",
            OperationInProgress: "Operació en curs",
            OperationRequestedAt: "Sol·licitada {{time}}",
            EditLockedBadge: "Bloquejat",
            EditLockedTitle: "Aquest dispositiu és actiu i no es pot editar.",
            EditLockedDescription: "Desactiva aquest dispositiu abans de canviar-ne la configuració, la imatge o les alarmes especials.",
            EditLockedMeta: "Desactiva'l per desbloquejar tota la configuració",
            Remove: "Remove",
            Create: "Create",
            DeviceInfo: "Device Information",
            SpecialAlarms: "Alarmes especials",
            SpecialAlarmsHelp:
                "Configura les notificacions de connectivitat i alimentació d'aquest dispositiu amb els canals del projecte.",
            SpecialAlarmConnection: "Notifica quan el dispositiu quedi fora de línia o torni a connectar-se",
            SpecialAlarmPowerSupply: "Notifica quan el dispositiu es desconnecti o torni a connectar-se al corrent",
            SpecialAlarmChannels: "Canals de notificació",
            SpecialAlarmChannelsHelp:
                "Els canals seleccionats es comparteixen entre tots dos grups d'alarmes especials d'aquest dispositiu.",
            SpecialAlarmChannelsEmpty:
                "Crea primer canals de notificació del projecte per enviar alarmes especials des d'aquest dispositiu.",
            DefaultSvantekConfig: "Configuració Svantek per defecte",
            DefaultSvantekConfigHelp: "Aquesta és la configuració que EMMA aplica quan la configuració personalitzada és buida.",
            CustomConfig: "Configuració Svantek personalitzada",
            CustomConfigDisabledWhenActive: "Desactiva el dispositiu abans de canviar la configuració Svantek personalitzada.",
            CustomConfigHelp: "Deixa-ho buit per fer servir la configuració Svantek per defecte d'Axioma inclosa a EMMA.",
            CustomConfigPlaceholder: "Enganxa la cadena completa de configuració de Svantek, començant per #1",
            SvantekFileSync: "Sincronització SVL i descàrregues",
            SvantekFileSyncEnabled: "Activa les descàrregues",
            SvantekFileSyncHelp:
                "Activa les descàrregues diàries de CSV, la sincronització del logger .SVL actiu i les lectures de fitxers Svantek d'aquest dispositiu.",
            SvantekBaselineSummary: "Resum base d'EMMA",
            SvantekBaselineSummaryHelp: "Aquests valors continuen sent només de lectura perquè la ingesta de dades d'EMMA en depèn.",
            SvantekOptionalFeatures: "Funcions opcionals",
            SvantekOptionalFeaturesHelp:
                "Els controls visuals només reescriuen els tokens Svantek compatibles i conserven la resta de la configuració.",
            SvantekAdvancedRawConfig: "Configuració raw avançada",
            SvantekAdvancedRawConfigHelp:
                "La cadena raw continua sent la font de veritat. Edita-la directament per a ajustos no compatibles o control manual complet.",
            SvantekRawConfigPreview: "Vista prèvia de la configuració personalitzada",
            SvantekRawConfigMissing: "Falten respecte de la configuració per defecte",
            SvantekRawConfigInvalid:
                "No s'ha pogut interpretar la configuració raw de Svantek. Corregeix-la o buida-la per tornar a activar l'editor visual.",
            SvantekCompatibilityWarning:
                "La configuració raw canvia tokens base d'EMMA. Es continuarà desant, però la compatibilitat de les dades es pot veure afectada.",
            SvantekUseInstrumentDefault: "Fes servir el valor per defecte del dispositiu",
            SvantekOn: "Activat",
            SvantekOff: "Desactivat",
            SvantekEnvironmental: "Ambiental",
            SvantekAirport: "Aeroport",
            SvantekMicrophoneCompensation: "Compensació del micròfon",
            SvantekFreeFieldCompensation: "Compensació de camp lliure",
            SvantekWaveRecordingMode: "Mode d'enregistrament wave",
            SvantekWaveRecordingOff: "Desactivat",
            SvantekWaveRecordingContinuous: "Contínua",
            SvantekWaveRecordingSlopePlus: "Pendent+",
            SvantekWaveRecordingSlopeMinus: "Pendent-",
            SvantekWaveRecordingGradientPlus: "Gradient+",
            SvantekWaveRecordingManual: "Manual",
            SvantekWaveRecordingIntegrationPeriod: "Període d'integ.",
            SvantekWaveRecordingLevelPlus: "Nivell+",
            SvantekWaveRecordingLevelMinus: "Nivell-",
            SvantekWaveRecordingExternal: "Extern",
            SvantekWaveRecordingAlarm: "Alarma",
            SvantekWaveFileName: "Nom del fitxer wave",
            SvantekWaveFileNameHelp: "Fins a 8 caràcters en majúscules, números o guions baixos.",
            SvantekWaveFormat: "Format",
            SvantekFormatPcm: "PCM",
            SvantekFormatExtensible: "Extensible",
            SvantekFormatALaw: "A-Law",
            SvantekBitsPerSample: "Bits per mostra",
            SvantekBits16: "16 bits",
            SvantekBits24: "24 bits",
            SvantekRecordingTime: "Temps d'enregistrament (s)",
            SvantekRecordingTimeHelp: "Interval permès: d'1 a 28800 segons.",
            SvantekPreTrigger: "Pretrigger (s)",
            SvantekPreTriggerHelp: "Disponible per als modes activats per nivell.",
            SvantekRecordingFilter: "Filtre d'enregistrament",
            SvantekSamplingRate: "Freqüència de mostreig",
            SvantekGain: "Guany (dB)",
            SvantekGainHelp: "Interval permès: de 0 a 40 dB.",
            SvantekTriggerLevel: "Nivell d'activació (dB)",
            SvantekTriggerLevelHelp: "Interval permès: de 24 a 136 dB.",
            SvantekTriggerPeriod: "Període d'activació",
            SvantekTriggerPeriodLoggerStep: "Pas del logger",
            SvantekTriggerPeriodHalfMillisecond: "0,5 ms",
            SvantekTriggerPeriod100Milliseconds: "100 ms",
            SvantekTriggerPeriod1Second: "1 s",
            SvantekTriggerGradient: "Gradient d'activació (dB)",
            SvantekTriggerGradientHelp: "Interval permès: d'1 a 100 dB per període d'activació.",
            SvantekLengthLimit: "Límit de longitud",
            SvantekLengthLimit4Gb: "Límit de fitxer de 4 GB",
            SvantekLengthLimitMinutes: "Minuts personalitzats",
            SvantekLengthLimitMinutesValue: "Límit de longitud (min)",
            SvantekFilterZ: "Filtre Z",
            SvantekFilterA: "Filtre A",
            SvantekFilterC: "Filtre C",
            SvantekFilterB: "Filtre B",
            SvantekSampling48kHz: "48 kHz",
            SvantekSampling24kHz: "24 kHz",
            SvantekSampling12kHz: "12 kHz",
            SvantekSampling6kHz: "6 kHz",
            SvantekBaselineMeasurementMode: "Mode de mesura",
            SvantekBaselineMeasurementModeValue: "1/3 d'octava",
            SvantekBaselineStartSynchronization: "Sincronització d'inici",
            SvantekBaselineStartSynchronizationValue: "15 min",
            SvantekBaselineIntegrationPeriod: "Període d'integració",
            SvantekBaselineIntegrationPeriodValue: "5 min",
            SvantekBaselineRepetitionCycles: "Cicles de repetició",
            SvantekBaselineRepetitionCyclesValue: "Infinit",
            SvantekBaselineLogger: "Logger",
            SvantekBaselineLoggerValue: "Activat",
            SvantekBaselineProfiles: "Perfils 1/2/3",
            SvantekBaselineProfilesValue: "A/C peak/Fast, A/C peak/Impulse, C/C peak/Fast",
            SvantekBaselineSpectrumFilter: "Filtre d'espectre",
            SvantekBaselineSpectrumFilterValue: "Z",
            SvantekBaselineLoggerStep: "Pas del logger",
            SvantekBaselineLoggerStepValue: "1 s",
            SvantekBaselineLeqDetector: "Detector Leq",
            SvantekBaselineLeqDetectorValue: "Exponencial",
            FolderFTP: "FTP Folder",
            ScheduledRestart: "Reinici programat",
            ScheduledRestartEnabled: "Activa el reinici automàtic",
            ScheduledRestartTimezone: "La programació fa servir la zona horària {{timezone}}.",
            ScheduledRestartFrequency: "Freqüència",
            ScheduledRestartWeekly: "Setmanal",
            ScheduledRestartMonthly: "Mensual",
            ScheduledRestartWeekday: "Dia de la setmana",
            ScheduledRestartMonthDay: "Dia del mes",
            ScheduledRestartHour: "Hora",
            ScheduledRestartMinute: "Minut",
            WeekdaySunday: "Diumenge",
            WeekdayMonday: "Dilluns",
            WeekdayTuesday: "Dimarts",
            WeekdayWednesday: "Dimecres",
            WeekdayThursday: "Dijous",
            WeekdayFriday: "Divendres",
            WeekdaySaturday: "Dissabte",
            XL3Connection: "Connexió XL3",
            XL3ConnectionType: "Tipus de connexió",
            XL3ConnectionLan: "LAN",
            XL3ConnectionConnect: "NTi Connect",
            XL3Host: "Host XL3",
            XL3ConnectKey: "Connect Key",
            XL3Password: "Contrasenya XL3",
            TotalStorageMb: "Emmagatzematge total (MB)",
            TotalStorageMbHelp: "Es fa servir per convertir l'espai lliure de NTi de MB a percentatge.",
            Address: "Address",
            Latitude: "Latitude",
            Longitude: "Longitude",
            SearchAddress: "Cerca adreça",
            SearchingAddress: "Resolent adreça",
            AddressHelp: "Escriu una adreça per obtenir-ne les coordenades.",
            MapHelp: "També pots fer clic al mapa per fixar les coordenades.",
            AddressNotFound: "No s’han trobat coordenades per a aquesta adreça.",
            GeocodeFailed: "Ara mateix no s’ha pogut resoldre l’adreça.",
            ReverseGeocodeFailed: "S’han fixat les coordenades, però no s’ha pogut resoldre l’adreça.",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            Projects: "Projectes",
            ConfirmActivate:
                "Aquest dispositiu ja està activat al projecte {{project}} amb el nom {{deviceName}}.  NEstà segur que voleu activar-lo?",
            Image: "Imatge",
            Files: "Arxius",
            FileName: "Nom",
            FileType: "Tipus d'arxiu",
            FileSize: "Mida",
            FileStatus: "Estat",
            FileCreationDate: "Data de creació",
            FileUploadDate: "Data de pujada",
            AllFileTypes: "Tots",
            CsvFiles: "CSV",
            SvlFiles: "SVL",
            Xl3Files: "Arxius XL3",
            FileStartDate: "Data inicial",
            FileEndDate: "Data final",
            ClearFileFilters: "Neteja els filtres",
            FileDateRangeError: "La data final ha de ser posterior o igual a la data inicial.",
            DownloadFile: "Descarregar",
            RescanFileStorage: "Revisa l'storage",
            RescanFileStorageCompleted: "{{count}} arxius recuperats",
            ReprocessFile: "Reprocessar",
            ReprocessFileQueued: "Reprocés SVL en cua",
            FileStatusUploaded: "Pujat",
            FileStatusPendingReprocess: "Pendent de reprocés",
            FileStatusReprocessing: "Reprocessant",
            FileStatusReprocessFailed: "Reprocés fallit",
            DownloadSelectedFiles: "Descarrega la selecció",
            SelectedFilesCount: "{{count}} seleccionats",
            SelectCurrentPageFiles: "Selecciona els arxius de la pàgina actual",
            SelectFile: "Selecciona {{name}}",
            NoFiles: "No hi ha arxius arxivats per a aquest dispositiu.",
            NoFilesMatchFilters: "No hi ha arxius arxivats que coincideixin amb els filtres actuals.",
            DropFiles: "Arrossegueu imatge aquí",
            RemoveImage: "Elimina la imatge",
            SearchPlaceholder: "Cercar",
        },
        DEVICE: {
            ALARM: {
                AlarmDeleteTitle: "Alerta",
                AlarmDeleteMessage: "Aquesta alarma té {{activeEvents}} esdeveniments actius. \nSegur que la vols eliminar?",
            },
        },
        PROJECTS: {
            Projects: "Projectes",
            Project: "Projecte",
            BasicInfo: "Info Bàsica",
            Name: "Nom",
            Timezone: "Zona horària",
            Devices: "Dispositius",
            Alarms: "Alarmas",
            Create: "Crea",
            ProjectName: "Nom del projecte",
            ADD: "AFEGEIX",
            SAVE: "GUARDA",
            CANCEL: "CANCEL·LA",
            ProjectPeriodName: "Nom",
            ProjectPeriodStart: "Hora d'inici",
            ProjectPeriodEnd: "Fi del temps",
            ProjectPeriodHours: "Hores",
            ProjectPeriodMinutes: "Minuts",
            ProjectPeriodNew: "Periode Nou",
            ProjectPeriodEdit: "Edita període",
            ProjectPeriodSave: "Guarda període",
            ProjectPeriodIntervals: "Intervals",
            ProjectPeriodAddInterval: "Afegeix interval",
            ProjectPeriodSplit: "Divideix",
            ProjectPeriodError:
                "ATENCIÓ: L'hora de finalització és abans de l'hora d'inici. Esteu creant un període que abasta diversos dies",
            ProjectPeriodsTimelineHint:
                "Useu la línia de temps per revisar els intervals de cada període. Editeu un període per gestionar-ne els intervals.",
            ProjectPeriodSplitHint: "Feu clic per dividir aquí",
            ProjectPeriodsEmptyTitle: "Creeu el primer període",
            ProjectPeriodsEmptyDescription: "Afegiu els períodes lògics que necessiteu i assigneu un o més intervals a cadascun.",
            Dateformat: "Format Data",
            Example: "Exemple",
            NotificationChannels: "Canals de notificació",
            NotificationChannelsHelp:
                "Creeu canals reutilitzables del projecte i seleccioneu-los des de les alarmes de dispositiu o projecte.",
            NotificationChannelAdd: "Afegeix canal",
            NotificationChannelNew: "Canal nou",
            NotificationChannelEdit: "Edita canal",
            NotificationChannelSave: "Desa canal",
            NotificationChannelName: "Nom del canal",
            NotificationChannelTypeLabel: "Tipus de canal",
            NotificationChannelEnabled: "Actiu",
            NotificationChannelRemove: "Elimina canal",
            NotificationChannelSendTest: "Enviar notificació de prova",
            NotificationChannelTestSent: "Notificació de prova enviada.",
            NotificationChannelTestFailed: "No s'ha pogut enviar la notificació de prova.",
            NotificationChannelEmails: "Destinataris email",
            NotificationChannelEmailsRequired: "Afegiu almenys un destinatari de correu.",
            NotificationChannelPhones: "Números de telèfon",
            NotificationChannelPhonesRequired: "Afegiu almenys un número de telèfon.",
            NotificationChannelChatIds: "IDs de xat de Telegram",
            NotificationChannelChatIdsRequired: "Afegiu almenys un ID de xat de Telegram.",
            NotificationChannelLanguage: "Idioma",
            NotificationChannelLanguageHint: "Les notificacions enviades per aquest canal faran servir l'idioma seleccionat.",
            NotificationChannelTelegramManagedBot:
                "L'enviament per Telegram fa servir el token del bot configurat al backend. Aquí només es gestionen els IDs de xat destinataris.",
            NotificationChannelWebhookUrl: "URL del webhook",
            NotificationChannelWebhookRequired: "La URL del webhook és obligatòria.",
            NotificationChannelListHint: "Feu servir comes o línies noves per introduir diversos valors.",
            NotificationChannelSecretStored: "Ja hi ha un secret desat. Deixeu-lo buit per mantenir-lo.",
            NotificationChannelWebPushHelp:
                "Crea aquí el canal web push. Els usuaris del projecte registren els seus propis navegadors des del flux de l'app per a clients.",
            NotificationChannelType: {
                email: "Email",
                sms: "SMS",
                telegram: "Telegram",
                slack: "Slack",
                teams: "Teams",
                web_push: "Web Push",
            },
            Archive: "Arxivar",
            Unarchive: "Desarxivar",
            ShowArchived: "Mostrar arxivats",
        },
    },
};
